import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'secondsToTime',
})
export class SecondsToTimePipe implements PipeTransform {
  transform(value: number): string {
    if (!value) {
      return '00:00';
    }
    let h = Math.floor(value / 3600);
    let m = Math.round((value % 3600) / 60);
    // eslint-disable-next-line no-comments/disallowComments
    //const s = Math.floor((value % 3600) % 60);
    if (m === 60) {
      m = 0;
      h += 1;
    }
    const hDisplay = h > 0 ? (h < 10 ? '0' + h : h) : '00';
    const mDisplay = m > 0 ? (m < 10 ? ':0' + m : ':' + m) : ':00';
    // eslint-disable-next-line no-comments/disallowComments
    //const sDisplay = s > 0 ? s + (s == 1 ? ' second' : ' seconds') : '';
    return hDisplay + mDisplay;
  }
}
